<template>
    <div>
        <div class="basket-col col-payment">
            <div class="basket-group" v-if="isDelivery">
                <div class="basket-group-title">{{phrases.TEXT_PAYMENT_TYPE}}</div>
                <div class="basket-group-buttons">
                    <div class="basket-group-button" :class="{ active: paymentType === 'courier'}"
                         @click="changePaymentType('courier', phrases.TEXT_PAYMENT_TYPE__COURIER_DESCRIPTION)">
                        {{phrases.TEXT_PAYMENT_TYPE__COURIER}}
                    </div>
                    <div class="basket-group-button" :class="{ active: paymentType === 'online'}"
                         @click="changePaymentType('online', phrases.TEXT_PAYMENT_TYPE__ONLINE_DESCRIPTION)">
                        {{phrases.TEXT_PAYMENT_TYPE__ONLINE}}
                    </div>
                </div>
                <div class="basket-group-description" v-if="paymentTypeDescription.length">{{ paymentTypeDescription }}</div>
                <div class="basket-group-description" v-else>{{ phrases.TEXT_PAYMENT_TYPE__COURIER_DESCRIPTION }}</div>
            </div>
            <div class="basket-group" v-if="paymentType === 'courier'">
                <div class="basket-group-title">{{ phrases.TEXT_CHOOSE_PAYMENT_TYPE }}</div>
                <div class="basket-group-buttons payment-type-buttons">
                    <div class="radio-button">
                        <input class="radio-button-input" id="payment-cash" type="radio" value="cash"
                               name="payment-type" @click="changePaymentCourierVariant('cash')"
                               :checked="paymentCourierVariant === 'cash'">
                        <label class="radio-button-label" for="payment-cash">{{ phrases.TEXT_PAYMENT_TYPE__CASH }}</label>
                    </div>
                    <div class="radio-button">
                        <input class="radio-button-input" id="payment-card" type="radio" value="kassa"
                               name="payment-type" @click="changePaymentCourierVariant('kassa')"
                               :checked="paymentCourierVariant === 'kassa'">
                        <label class="radio-button-label" for="payment-card">{{ phrases.TEXT_PAYMENT_TYPE__CARD }}</label>
                    </div>
                    <div class="radio-button full-width">
                        <input class="radio-button-input" id="payment-qr-code" type="radio" value="qr"
                               name="payment-type" @click="changePaymentCourierVariant('qr')"
                               :checked="paymentCourierVariant === 'qr'">
                        <label class="radio-button-label" for="payment-qr-code">{{ phrases.TEXT_PAYMENT_TYPE__QR }}</label>
                    </div>
                </div>
            </div>
            <div class="basket-group" v-if="paymentType === 'courier' && paymentCourierVariant === 'cash'">
                <div class="basket-group-title">{{ phrases.TEXT_PREPARE_CHANGE }}</div>
                <div class="basket-group-field change-box" v-if="!noChange">
                    <input class="basket-group-input size-lg" :class="{'field-error': getFieldErrorState(requiredFields.sumChange)}"
                           type="text" :placeholder="phrases.TEXT_ENTER_SUM"
                           v-model="sum_change">
                </div>
                <div class="basket-group-field">
                    <label class="checkbox" for="no-change">
                        <input type="checkbox" id="no-change"
                               name="no-change"
                               @click="changeNoChange"
                               :checked="noChange">
                        <div class="checkbox-input"><span class="pp-icon pp-icon-checkbox"></span></div>
                        <div class="checkbox-title">{{ phrases.TEXT_NO_CHANGE }}</div>
                    </label>
                </div>
            </div>
            <div class="basket-group" v-if="!isDelivery">
                <div class="basket-group-title">{{ phrases.TEXT_PAYMENT_TYPE }}</div>
                <div class="basket-group-buttons">
                    <div class="basket-group-button" :class="{ active: paymentType === 'cash'}"
                         @click="changePaymentType('cash', phrases.TEXT_PAYMENT_TYPE__IN_PIZZA_DESCRIPTION)">
                        {{phrases.TEXT_PAYMENT_TYPE__IN_PIZZA}}
                    </div>
                    <div class="basket-group-button" :class="{ active: paymentType === 'online'}"
                         @click="changePaymentType('online', phrases.TEXT_PAYMENT_TYPE__ONLINE_DESCRIPTION)">
                        {{phrases.TEXT_PAYMENT_TYPE__ONLINE}}
                    </div>
                </div>
                <div class="basket-group-description" v-if="paymentTypeDescription.length">{{ paymentTypeDescription }}</div>
            </div>
            <div class="basket-group">
                <div class="switcher">
                    <div class="switcher-title">{{phrases.TEXT_TO_USE}} {{phrases.TEXT_BONUSES}}</div>
                    <input id="use-bonus" name="use-bonus" value="1" type="checkbox" @click="changeUseBonus" :checked="isUseBonus">
                    <label class="switcher-toggle theme-green" for="use-bonus"></label>
                </div>
                <div class="basket-bonus-box" v-if="useBonus">
                    <div class="basket-group-title bonus-title">{{ phrases.TEXT_YOU_HAVE }} {{ userBonuses }} {{ userBonusPhrase }}</div>
                    <div class="input-range-box" v-if="userBonuses >= min_bonus_value">
                        <div class="bonus__range-value">{{ min_bonus_value }}</div>
                        <input class="input-range" type="range" :step="min_bonus_value" v-model="offBonusValue" :min="min_bonus_value" data-id="bonuses-input"
                               name="bonuses" :max="userBonuses">
                        <div class="bonus__range-value text-right user__bonus-value">{{ userBonuses }}</div>
                    </div>
                    <div class="bonus-description" v-if="userBonuses >= 5">
                        <div>{{phrases.TEXT_WRITE_OFF}}:</div>
                        <div class="basket-group-field size-sm">
                            <input class="basket-group-input" :class="{'field-error': getFieldErrorState(requiredFields.bonusCount)}"
                                   type="text" name="bonus-count" v-model="offBonusValue">
                        </div>
                        <div class="bonus-title"> {{ offBonusPhrase }}</div>
                    </div>
                </div>
            </div>
            <Promocode></Promocode>
            <div class="basket-group">
                <div class="basket-group-title">{{phrases.TEXT_ORDER_DESCRIPTION}}</div>
                <div class="basket-group-field">
                    <textarea class="basket-group-textarea" :placeholder="this.phrases.TEXT_ORDER_DESCRIPTION_PLACEHOLDER"
                              v-model="comment"></textarea>
                </div>
            </div>
            <div class="basket-group" v-if="isOnlinePayment">
              <div class="basket-group-title">{{ phrases.BASKET_SEND_CHECK_TO_EMAIL }}</div>
              <div class="basket-group-field">
                <input v-model="paymentUserEmail" :class="{'field-error': getFieldErrorState(requiredFields.userEmail)}"
                       class="basket-group-input size-lg" type="text" :placeholder="phrases.BASKET_USER_EMAIL">
              </div>
            </div>
            <div class="basket-group">
                <div v-if="isOnlinePayment" class="basket-group-description online-payment-note">
                  {{ phrases.ONLINE_PAYMENT_NOTE }}
                </div>
                <div v-if="isOnlinePayment" id="payment-form"></div>
                <div v-if="showSendButton()" class="button-confirm-order goal-confirm-order"
                     :class="{'button-processing': (processing || process_discount)}" @click="confirmOrder">
                  <span v-if="!(processing || process_discount)">{{orderButtonText}}</span>
                  <div v-if="(processing || process_discount)" class="button-loader"></div>
                </div>
                <div class="basket-note-text" v-for="(error, index) in orderErrors" :key="index">{{ error }}</div>
            </div>
            <div v-if="isShowIncreaseOrderTimeConfirmation" class="increase-delivery-time">
              <div class="increase-delivery-time-body">
                {{ increaseOrderTimeConformationText }}
              </div>
              <div class="increase-delivery-time-footer">
                <div class="confirm-button" @click="acceptOrderWithIncreaseTime()">{{phrases.YES}}</div>
                <div class="confirm-button" @click="declineOrderWithIncreaseTime()">{{phrases.NO}}</div>
              </div>
            </div>
            <div v-if="isShowPaidDeliveryConfirmation" class="increase-delivery-time">
              <div class="increase-delivery-time-body">
                {{ paidDeliveryConformationText }}
              </div>
              <div class="increase-delivery-time-footer">
                <div class="confirm-button" @click="acceptOrderWithPaidDelivery()">{{phrases.YES}}</div>
                <div class="confirm-button" @click="declineOrderWithPaidDelivery()">{{phrases.NO}}</div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Utils from "../Utils";
    import Promocode from "./Promocode";
    import Checkout from "./Checkout";

    export default {
      name: "Payment",
      components: {Promocode},
      data: function(){
        return{
            paymentTypeDescription: "",
            processing: false,
            comment: null,
            sum_change: null,
            min_bonus_value: 5,
            showConfirmButton: true,
            acceptIncreaseOrderTime: false,
            increaseOrderTimeConformationText: null,
            paidDeliveryConformationText: null,
            acceptPaidDelivery: null,
        };
        },
        watch:{
            isDelivery: function () {
                if(this.paymentType !== 'online'){
                    let type = 'courier';
                    let typeDescription = this.phrases.TEXT_PAYMENT_TYPE__COURIER_DESCRIPTION;
                    if(!this.isDelivery){
                        type = 'cash';
                        typeDescription = this.phrases.TEXT_PAYMENT_TYPE__IN_PIZZA_DESCRIPTION;
                    }
                    this.changePaymentType(type, typeDescription)
                }
            },
            comment:function () {
                this.$store.dispatch({
                    type: 'order/setOrderComment',
                    orderComment: this.comment,
                });
            },
            sum_change:function () {
                const change = this.sum_change;
                this.$store.dispatch({
                    type: 'order/setChangeValue',
                    changeValue: change,
                });
            },
        },
        methods: {
            changePaymentType(paymentType, paymentTypeDescription){
                this.paymentTypeDescription = paymentTypeDescription;
                this.$store.dispatch({
                    type: 'order/changePaymentType',
                    paymentType: paymentType,
                });
            },
            changePaymentCourierVariant(paymentCourierVariant){
                this.$store.dispatch({
                    type: 'order/setPaymentCourierVariant',
                    paymentCourierVariant: paymentCourierVariant,
                });
            },
            changeNoChange(){
                const noChange = !this.noChange;
                this.$store.dispatch({
                    type: 'order/setNoChange',
                    noChange: noChange,
                });
            },
            changeUseBonus(){
                const useBonus = !this.useBonus;

                this.$store.dispatch({
                    type: 'order/setUseBonus',
                    useBonus: useBonus,
                });
            },
            confirmOrder(){
                const component = this;
                this.error = false;
                if(this.processing === true || this.process_discount === true){
                    return false;
                }

                const order = this.collectOrderInfo();
                this.verifyInfo();

                if(this.orderErrors.length > 0){
                    return false;
                }else{
                    this.processing = true;
                    const pizzeria_id = component.pizzeriaInfo.pizzeria_id;
                    const pizzeria_point_id = component.pizzeria_point_id;
                    this.sendRequest('send-order', {
                        order: order,
                        pizzeria_id: pizzeria_id,
                        pizzeria_point_id: pizzeria_point_id,
                        acceptIncreaseOrderTime: component.acceptIncreaseOrderTime,
                        accept_paid_delivery: component.acceptPaidDelivery
                    }).then(response => {
                        const data = response.data;

                        if(data.status === "error"){
                            component.processOrderException(data);
                        }else{
                            const order_id = data.order_id;
                            const order_status = data.order_status;
                            const order_number = data.number;
                            const dateDelivery = data.dateDelivery;

                            const orderData = Object.assign(order, {
                              dateDelivery: dateDelivery,
                              number: order_number,
                              delayTimeFrom: data.delayTimeFrom,
                              delayTimeTo: data.delayTimeTo
                            });
                            if (order_id !== undefined && order_id !== null) {
                                orderData['created'] = true;
                                const orderItem = {"status": order_status, "id": order_id, "data": orderData};
                                this.setConfirm();
                                this.$store.dispatch({
                                    type: 'order/saveOrder',
                                    order: orderItem,
                                });
                                const orderCookies = {id: order_id};
                                this.$cookies.set('order', orderCookies);
                                this.checkOrderStatus(order_id, null);
                                this.sendOrderToGoogleTagManager(order_id, orderData);
                            }else if(data['confirmation_code'] !== undefined && data['confirmation_code'] !== null){
                                const order_id = data['id'];
                                const payment_id = data['payment_id'];
                                if(!component.isDevMode) {
                                  component.renderPaymentForm(data['confirmation_code'], payment_id, order_id, component.city);
                                }
                                this.showConfirmButton = false;
                                const orderItem = {"status": null, "id": null, "payment_id": payment_id, "data": orderData};
                                this.$store.dispatch({
                                    type: 'order/saveOrder',
                                    order: orderItem,
                                });
                                this.$cookies.set(this.cookie_online_payment,
                                    {payment_id: payment_id, order_id: order_id}, this.cookie_online_payment_expired);
                            }
                        }
                    }).catch(error => {
                        console.error("confirmOrder", error);
                        component.addError(
                            error.response !== undefined ? error.response : component.errorText("SOMETHING_WRONG"));
                    }).finally(() =>{
                      this.processing = false;
                    })
                }
            },
            verifyInfo(){
                const component = this;
                component.$store.commit("basket/clearRequiredFieldError");
                component.$store.commit("order/setOrderErrors", []);
                if(this.user.name === null || this.user.name.length === 0){
                    component.addError(component.errorText('FILL_NAME'));
                }

                const minOrderSum = this.pizzeria.min_order_sum;
                const maxOrderSum = this.pizzeria.max_order_sum;
                const maxOrderOnlineSum = this.pizzeria.max_order_online_sum;
                const maxCommentLength = 500;

                if(this.isDelivery) {
                    if (this.total.sum < minOrderSum) {
                        component.addError([component.errorText('MIN_SUM_ORDER_IS'), minOrderSum].join(" "));
                    }
                }

                if(this.paymentType === "online"){
                    if(this.total.sum > maxOrderOnlineSum) {
                        component.addError([component.errorText('MAX_SUM_ORDER_IS'), maxOrderOnlineSum].join(" "));
                    }
                    if(this.paymentUserEmail === null || this.paymentUserEmail === undefined
                        || this.paymentUserEmail.length === 0){
                      component.addFieldErrorState(component.requiredFields.userEmail, true);
                      component.addError(component.errorText('PLEASE_ENTER_EMAIL_ADDRESS'));
                    }
                    if(this.paymentUserEmail.search('@') < 0){
                      component.addFieldErrorState(component.requiredFields.userEmail, true);
                      component.addError(component.errorText('WRONG_EMAIL_FORMAT'));
                    }
                }else{
                    if(this.total.sum > maxOrderSum){
                        component.addError(component.phrases.MAX_SUM_ORDER_IS.replace(/%s/, maxOrderSum + component.phrases.TEXT_RUB));
                    }
                }

                if(this.isDeferOrder){
                  if(this.deferOrderDate === null || this.deferOrderTime === null){
                    component.addError(component.errorText('FILL_ORDER_TIME'));
                  }
                }

                if(this.isDelivery){
                    const address = Object.assign({}, this.deliveryAddress);
                    if(address.street.ext_id === null || address.street.ext_id.length === 0){
                        component.addFieldErrorState(component.requiredFields.street, true);
                        component.addError(component.errorText('FILL_STREET'));
                    }
                    if(address.house === null || address.house.length === 0){
                        component.addFieldErrorState(component.requiredFields.house, true);
                        component.addError(component.errorText('FILL_HOUSE'));
                    }
                    const fieldsTitle = {'house': "TEXT_HOUSE", 'building': "TEXT_BUILDING", 'entrance': "TEXT_ENTRANCE",
                      'floor': "TEXT_FLOOR", 'flat': "TEXT_OFF_APT", 'doorphone': "TEXT_ENTRANCE_CODE"};
                    Object.keys(address).forEach(function(field){
                        if(field !== "street"){
                            const value = address[field];
                            if(value !== null && value.length > 10){
                                component.addError(
                                    component.errorText('WRONG_FIELD_LENGTH_MAX_LENGTH')
                                    .replace(/%s/, component.errorText(fieldsTitle[field]))
                                        .replace(/%s/, 10));
                                component.addFieldErrorState(field, true);
                            }
                        }
                    });

                    if(this.paymentType === "courier" && this.paymentCourierVariant === "cash" && !this.noChange){
                        const changeValue = parseInt(this.changeValue);
                        const totalSum = this.total_order_sum;
                        if(isNaN(changeValue)){
                            component.addFieldErrorState(component.requiredFields.sumChange, true);
                            component.addError(component.errorText('FILL_CHANGE_VALUE'));
                        }else if(changeValue < totalSum){
                            component.addFieldErrorState(component.requiredFields.sumChange, true);
                            component.addError(component.errorText('UNCORRECT_CHANGE_VALUE'));
                        }
                    }
                }

                if(component.useBonus && component.useBonusValue > component.userBonuses){
                  component.addFieldErrorState(component.requiredFields.bonusCount, true);
                  component.addError(component.errorText('WRONG_ORDER_BONUS_COUNT'));
                }

                const couponValue = (component.coupon !== null && component.coupon !== undefined && component.coupon.length);
                const errorCouponStatus = component.couponStatus !== null && component.couponStatus !== component.COUPON_STATUS_HAS_BEEN_APPLIED;
                if(couponValue && errorCouponStatus){
                  component.addError(component.errorText('TEXT_' + component.couponStatus));
                }

                if (this.comment != null) {
                  if (this.comment.length > maxCommentLength) {
                  component.addError(
                      component.errorText('WRONG_FIELD_LENGTH_MAX_LENGTH')
                          .replace(/%s/, component.errorText(this.phrases.TEXT_ORDER_DESCRIPTION))
                          .replace(/%s/, maxCommentLength));
                  return false;
                  }
                }
            },
            addError: function(error){
              this.$store.commit("order/addOrderError", error);
            },
            processOrderException(response){
              const component = this;
              if(response['error-type'] === "pizzeria-overload"){
                component.showIncreaseDeliveryTimeConfirmation(response['error']);
              }else if(response['error-type'] === "paid-delivery-exception"){
                component.showPaidDeliveryConfirmation(response['error']);
                component.$store.commit("order/setDeliverySum", response['delivery-sum']);
              }else{
                component.addError(component.errorText(response['error']));
                if(response['details'] !== undefined && response['details'] !== null){
                  component.addError(response['details']);
                }
              }
            },
            renderPaymentForm(confirmationCode, paymentId, orderId, cityCode){
              const redirect_url =  window.location.origin +
                  (window.location.pathname === "/trudovoe/" ? "/trudovoe/" : "") + '?' +
                  ['payment_id=' + paymentId, 'order_id=' + orderId, 'city=' + cityCode].join("&");
              const checkout = new window.YooMoneyCheckoutWidget({
                confirmation_token: confirmationCode, //Токен, который перед проведением оплаты нужно получить от Яндекс.Кассы
                return_url: redirect_url, //Ссылка на страницу завершения оплаты
                error_callback(error) {
                  //Обработка ошибок инициализации
                  console.log(error);
                }
              });
              //Отображение платежной формы в контейнере
              checkout.render('payment-form');
            },
            showIncreaseDeliveryTimeConfirmation(conformationText){
              this.$store.commit('app/setShowIncreaseOrderTimeConformation', true);
              this.increaseOrderTimeConformationText = conformationText;
            },
            acceptOrderWithIncreaseTime(){
              this.acceptIncreaseOrderTime = true;
              this.$store.commit('app/setShowIncreaseOrderTimeConformation', false);
              this.confirmOrder();
            },
            showPaidDeliveryConfirmation(conformationText){
              this.$store.commit('app/setShowPaidDeliveryConfirmation', true);
              this.paidDeliveryConformationText = conformationText;
            },
            acceptOrderWithPaidDelivery(){
              this.acceptPaidDelivery = true;
              this.$store.commit('app/setShowPaidDeliveryConfirmation', false);
              this.confirmOrder();
            },
            showSendButton(){
              return this.showConfirmButton && !this.isShowIncreaseOrderTimeConfirmation && !this.isShowPaidDeliveryConfirmation;
            }
        },
        computed: {
            ...mapGetters('order', {
                isDelivery: 'isDelivery',
                isDeferOrder: 'isDeferOrder',
                deferOrderTime: 'deferOrderTime',
                paymentType: 'paymentType',
                paymentCourierVariant: 'getPaymentCourierVariant',
                noChange: 'isNoChange',
                changeValue: 'changeValue',
                useBonus: 'isUseBonus',
                useBonusValue: 'useBonusValue',
                orderComment: 'orderComment',
                total: 'total',
                productItems: 'basketItems',
                deliveryAddress: 'deliveryAddress',
                saveAddress: 'getSaveAddress',
                user: 'getUserInfo',
                coupon: 'getCoupon',
                couponStatus: 'getCouponStatus',
                pizzeria_point_id: 'getPizzeriaPointId',
                orderErrors: 'getOrderErrors',
            }),
            ...mapGetters('user', {
                userBonuses: 'getBonuses',
            }),
            ...mapGetters('app', {
                phrases: 'getPhrases',
                pizzeria: 'getPizzeriaInfo',
                city: 'getCityCode',
                isDevMode: 'getIsDevMode',
                isShowIncreaseOrderTimeConfirmation: 'getShowIncreaseOrderTimeConformation',
                isShowPaidDeliveryConfirmation: 'getShowPaidDeliveryConfirmation',
            }),
            offBonusValue:{
                get(){
                  return this.$store.state.order.useBonusValue;
                },
                set(value) {
                  this.$store.commit('order/setUseBonusValue', value);
                }
            },
            userBonusPhrase: function () {
                return this.morph(this.userBonuses, this.phrases.TEXT_COUNT_BONUS, this.phrases.TEXT_COUNT_BONUS_2, this.phrases.TEXT_COUNT_BONUSES);
            },
            offBonusPhrase: function () {
                return this.morph(this.useBonusValue, this.phrases.TEXT_COUNT_BONUS, this.phrases.TEXT_COUNT_BONUS_2, this.phrases.TEXT_COUNT_BONUSES);
            },
            orderButtonText: function () {
                if(this.process_discount){
                  return this.phrases.TEXT_WAITING_FOR_REQUEST;
                }
                return this.isOnlinePayment ?  this.phrases.TEXT_GO_TO_PAYMENT : this.phrases.TEXT_BUTTON_SEND_ORDER;
            },
            isOnlinePayment(){
                return this.paymentType === 'online';
            },
            paymentUserEmail: {
              get () {
                  return this.$store.state.order.user.email;
              },
              set (email) {
                this.$store.dispatch({
                  type: 'order/setUserInfo',
                  user: {email: email},
                });
              },
            },
        },
        mixins: [Utils, Checkout],
        mounted() {},
      }
</script>
<style lang="scss">
  .increase-delivery-time{
    padding: 0.25rem;
    border: 2px solid #333;
    line-height: 1.25rem;
    text-align: center;

    &-footer{
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0.5rem 0 0 0;

      .confirm-button{
        padding: 0.25rem;
        border: 2px solid #333;
        width: 30%;
        cursor: pointer;

        &:hover{
          background-color: #333;
          color: #fff;
        }

        &:nth-child(2n){
          margin: 0 0 0 1rem;
        }
      }
    }
  }
</style>
